import { render, staticRenderFns } from "./SiteClientContactList.vue?vue&type=template&id=1036ea8d"
import script from "./SiteClientContactList.vue?vue&type=script&lang=js"
export * from "./SiteClientContactList.vue?vue&type=script&lang=js"
import style0 from "./SiteClientContactList.vue?vue&type=style&index=0&id=1036ea8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports